import type { FormValues } from '../types';

export function comfortGranularAny(
  v: Pick<
    FormValues,
    | 'include_comfort_related_full_name'
    | 'include_comfort_related_height'
    | 'include_comfort_related_weight'
    | 'include_comfort_related_details'
  >
): boolean {
  return (
    v.include_comfort_related_full_name ||
    v.include_comfort_related_height ||
    v.include_comfort_related_weight ||
    v.include_comfort_related_details
  );
}

export function passportGranularAny(
  v: Pick<
    FormValues,
    | 'include_passport_details_passport_number'
    | 'include_passport_details_document_date_of_birth'
    | 'include_passport_details_expiry_date'
  >,
  opts: { ignoreDocumentDob?: boolean } = {}
): boolean {
  const documentDob = opts.ignoreDocumentDob ? false : v.include_passport_details_document_date_of_birth;

  return (
    v.include_passport_details_passport_number || documentDob || v.include_passport_details_expiry_date
  );
}

export function loyaltyGranularAny(
  v: Pick<
    FormValues,
    'include_loyalty_program_full_name' | 'include_loyalty_program_program' | 'include_loyalty_program_number'
  >
): boolean {
  return v.include_loyalty_program_full_name || v.include_loyalty_program_program || v.include_loyalty_program_number;
}
